import React from "react";

import { t } from "../utils/ResourceUtils";

const PageNoteFound = () => {
  return (
    <div className="page-not-found-wrapper">
      <img src="/assets/404.svg" alt="404" />
      <h2>{t("cm.we_cant_seem_to_find")}</h2>
      <div className="back-to-home">
        <a href="/dashboard">{t("cm.back_to_home")}</a>
      </div>
    </div>
  );
};

export default PageNoteFound;
